import "../ws8/ws8.css";
import { ClipView } from "../ws8/clip/ClipView";

/** Clip (/clips/:clipId). Owned by WS8 (implementation in web/src/ws8/clip). */
export function ClipPage() {
  return <ClipView />;
}
